import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FaRegBookmark,
  FaRegComment,
  FaRegHeart,
  FaRegPaperPlane,
} from "react-icons/fa";
import { useEffect, useState } from "react";
import SeeCommentsModal from "./modals/SeeCommentsModal";
import apiCall from "components/Api/api";

const Feed3 = () => {
  const [feeds, setFeeds] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState();
  const [expanded, setExpanded] = useState(false);
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [likes, setLikes] = useState({});
  const [likedPosts, setLikedPosts] = useState({});

  const handleLikeClick = (feedId) => {
    setLikes((prevLikes) => ({
      ...prevLikes,
      [feedId]: (prevLikes[feedId] || 0) + (likedPosts[feedId] ? -1 : 1),
    }));

    setLikedPosts((prevLiked) => ({
      ...prevLiked,
      [feedId]: !prevLiked[feedId],
    }));
  };

  const toggleDropdown = (id) => {
    setActiveDropdownId((prev) => (prev === id ? null : id));
  };

  const fetchFeeds = async (currentPage = 1, currentPageSize = 5) => {
    try {
      if (currentPage === 1) {
        setLoading(true);
      } else {
        setLoadingMore(true);
      }

      const response = await apiCall({
        url: `feeds`,
        method: "GET",
      });

      if (response?.status === 200) {
        const feedData = response?.data?.data?.feeds || [];

        setFeeds((prev) => {
          const existingIds = new Set(prev.map((f) => f.id));
          const newFeeds = feedData.filter((f) => !existingIds.has(f.id));
          return [...prev, ...newFeeds];
        });

        setHasMore(feedData.length > 0);
      } else {
        throw new Error("Failed to load feeds.");
      }
    } catch (err) {
      setError(err.message || "Something went wrong!");
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    fetchFeeds(page, 5);
  }, [page]);

  return (
    <>
      <section className="mainT margin_bottomfooter">
        <Container fluid="lg">
          <Row className="justify-content-center">
            <Col lg={6} className="bg-white px-3 pb-3">
              {feeds?.length > 0 && (
                <>
                  {feeds?.map((feed, index) => (
                    <Col lg={12} key={index.id}>
                      <Col xs={12} className="position-relative">
                        <div className="py-3 d-flex align-items-center justify-content-between">
                          <div className="userProfileParent d-flex align-items-center gap-2">
                            <div className="useProfile p-1 d-flex align-items-center justify-content-center">
                              <Link to="">
                                <img
                                  src={
                                    // feed?.feed?.post_user_detail?.[0]
                                    //   ?.image
                                    feed?.feed?.post_user_detail?.image
                                  }
                                  alt=""
                                  className="w-100 h-100 object-fit-cover"
                                />
                              </Link>
                            </div>
                            <div className="userName d-flex align-items-center gap-2">
                              {/* {feed?.feed?.interested_users?.[0]?.name && (
                                <Link to="" className="userMain text-dark">
                                  {feed.feed.interested_users[0].name}
                                </Link>
                              )} */}
                              <Link to="" className="userMain text-dark">
                                {feed?.feed?.post_user_detail?.name}
                              </Link>
                              <div className="hours">
                                <span>2 hour ago</span>
                              </div>
                            </div>
                          </div>
                          <div className="followBtn d-flex align-items-center gap-3">
                            <button className="followmainBtn">Follow</button>
                            <div className="dotIcon">
                              <Link
                                to=""
                                className=""
                                onClick={() => toggleDropdown(feed.id)}
                              >
                                <FontAwesomeIcon
                                  icon={faEllipsisV}
                                  style={{ fontSize: "22px", color: "#000" }}
                                />
                              </Link>
                            </div>
                          </div>
                        </div>
                        {activeDropdownId === feed.id && (
                          <Link to="" className="p-10 bg-white reportDown">
                            Report
                          </Link>
                        )}
                      </Col>
                      <Col lg={12} className="pb-2">
                        <div className="h-100 w-100">
                          <img
                            src={feed?.feed?.full_image_path}
                            alt=""
                            className="w-100 h-100"
                            style={{ borderRadius: "5px" }}
                          />
                        </div>
                      </Col>
                      <Col lg={12} className="pb-2">
                        <div className="socialIconsMAin d-flex justify-content-between">
                          <div className="icons d-flex gap-3">
                            <Link
                              to=""
                              onClick={() => handleLikeClick(feed.id)}
                            >
                              <FaRegHeart
                                className="iKon"
                                style={{
                                  color: likedPosts[feed.id] ? "red" : "black",
                                }}
                              />
                            </Link>

                            <Link to="" onClick={() => setModalOpen(true)}>
                              <FaRegComment className="iKon" />{" "}
                            </Link>
                            <Link to="">
                              <FaRegPaperPlane className="iKon" />
                            </Link>
                          </div>
                          <div className="icons">
                            <Link to="">
                              <FaRegBookmark className="iKon" />
                            </Link>
                          </div>
                        </div>
                      </Col>
                      <Col lg={12} className="pb-2">
                        <div className="likesCounter">
                          <Link to="" className="likes">
                            {likes[feed.id] !== undefined
                              ? likes[feed.id]
                              : feed?.feed?.likes_count || 0}
                          </Link>
                        </div>
                      </Col>
                      <Col lg={12} className="pb-2">
                        <div className="d-flex gap-2 mb-0">
                          <div className="commentetrsProfileName">
                            <p className="mb-0">
                              <Link to="" className="me-1 commentUserMain">
                                {feed?.feed?.post_user_detail?.name}
                              </Link>
                              {feed?.feed?.post_user_detail?.subtitle}
                            </p>
                          </div>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="seeComments">
                          <button
                            to=""
                            className="seeCmt"
                            onClick={() => setModalOpen(true)}
                          >
                            see all comments
                          </button>
                        </div>
                        <div className="addComments position-relative">
                          <input
                            type="text"
                            placeholder="Add a comment..."
                            className="commentsIpnut w-100 border-bottom"
                          />
                        </div>
                      </Col>
                    </Col>
                  ))}
                </>
              )}
            </Col>
          </Row>
        </Container>
        <SeeCommentsModal
          feedData={feeds}
          show={modalOpen}
          handleClose={() => setModalOpen(false)}
        />
      </section>
    </>
  );
};
export default Feed3;
